import type { CompareLeft, CompareRight } from '../../data-contract/position-alignment';
import type { AlignmentActingRole } from '../../fetchers/position-alignment/position-alignment-fetchers';

export const positionAlignmentKeys = {
    alignment: (alignmentId: string, as?: AlignmentActingRole) =>
        [...positionAlignmentKeys.alignmentViews(alignmentId), as ?? null] as const,
    alignmentScope: (alignmentId: string) => [...positionAlignmentKeys.alignments(), alignmentId] as const,
    alignmentViews: (alignmentId: string) => [...positionAlignmentKeys.alignmentScope(alignmentId), 'view'] as const,
    alignments: () => [...positionAlignmentKeys.all, 'alignment'] as const,
    all: ['position-alignment'] as const,
    automations: (alignmentId: string) =>
        [...positionAlignmentKeys.alignmentScope(alignmentId), 'automations'] as const,
    compare: (alignmentId: string, left: CompareLeft, right: CompareRight) =>
        [...positionAlignmentKeys.compares(alignmentId), left, right] as const,
    compares: (alignmentId: string) => [...positionAlignmentKeys.alignmentScope(alignmentId), 'compare'] as const,
    task: (alignmentId: string, taskId: string, as?: AlignmentActingRole) =>
        [...positionAlignmentKeys.tasks(alignmentId), taskId, as ?? null] as const,
    taskAutomationRecommendation: (alignmentId: string, taskId: string) =>
        [...positionAlignmentKeys.tasks(alignmentId), taskId, 'automation-recommendation'] as const,
    tasks: (alignmentId: string) => [...positionAlignmentKeys.alignmentScope(alignmentId), 'task'] as const,
    positionAlignments: (positionId: string) => [...positionAlignmentKeys.positions(), positionId] as const,
    positions: () => [...positionAlignmentKeys.all, 'position'] as const,
    position: (alignmentId: string, as?: AlignmentActingRole) =>
        [...positionAlignmentKeys.alignmentScope(alignmentId), 'position', as ?? null] as const,
    me: () => [...positionAlignmentKeys.all, 'me'] as const,
    team: () => [...positionAlignmentKeys.all, 'team'] as const,
    threads: (alignmentId: string) => [...positionAlignmentKeys.alignmentScope(alignmentId), 'threads'] as const,
} as const;
